var gql = require("@apollo/client").gql;

const OPERATORS_QUERY = gql`
	query Operators($filter: String, $limit: Int!, $offset: Int!, $sort: String) {
		operators(filter: $filter, limit: $limit, offset: $offset, sort: $sort, random: true) {
			pagination {
				items_count
				items_total
				per_page
				page_current
				page_total
			}
			data {
				id
				name
				url_name
				translit_name
				logo
				sell_self {
					provider {
						id
						name
						logo
						url_name
						region {
							url
						}
					}
				}
				region {
					id
					name
					url
				}
				info {
					cnt_tariffs
					cnt_action_tariffs
					min_minutes
					max_minutes
					min_gigabytes
					max_gigabytes
					min_price
					max_price
				}
				vip_provider
				vip_provider_b2b
				vip_provider_b2b_link
				vip_provider_b2b_sat
				vip_provider_b2b_sat_link
				vip_b2c_priority
			}
		}
	}
`;

export default OPERATORS_QUERY;
